import { createApp } from "vue";
import "polyfill-object.fromentries";
import App from "./app.vue";
import { setupStore } from "@/store";

import {
  router,
  setupRouter,
  setupAntDesign,
  setupGlobalDirectives,
  setupGlobalComponents,
  setupGlobalMethods,
  setupThirdLib,
  setupGlobalFilters,
  setupCkeditor,
} from "@/core";
import yiguanSdk from '@/core/yiguan-sdk'


const app = createApp(App);
import "./assets/styles/flex.css";

// 易观sdk在router之前
setupGlobalMethods(app);

app.use(yiguanSdk)
setupStore(app);
setupAntDesign(app);
setupRouter(app);
setupGlobalComponents(app);
setupGlobalDirectives(app);
setupThirdLib(app);
setupGlobalFilters(app);
setupCkeditor(app);

import "xe-utils";
import VXETable from "vxe-table";
import VxeUI from 'vxe-pc-ui'
import "@/components/table-wrapper/index.scss";
app.use(VxeUI).use(VXETable);

router.isReady().then(() => app.mount("#app"));
